import React from "react";
import { Card, CardContent } from "./ui/card";
import { TrendingUp, TrendingDown, DollarSign, BarChart3 } from "lucide-react";

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/**
 * KPIs do Dashboard principal: Entradas, Saídas, Vendas e Saldo (soma dos bancos).
 * Mantém a mesma aparência/testids da versão original para não quebrar testes.
 */
export default function DashboardKPIs({ stats = {}, bankAccounts = [] }) {
  const totalBankBalance = (bankAccounts || []).reduce(
    (s, b) => s + (parseFloat(b.current_balance) || 0),
    0
  );
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-6 md:mb-8">
      <Card className="bg-gradient-to-r from-green-500 to-green-600 text-white">
        <CardContent className="p-6">
          <div className="flex items-center">
            <TrendingUp className="h-8 w-8 text-green-100" />
            <div className="ml-4">
              <p className="text-green-100">Entradas</p>
              <p className="text-xl md:text-2xl font-bold">{formatCurrency(stats.total_entrada)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-r from-red-500 to-red-600 text-white">
        <CardContent className="p-6">
          <div className="flex items-center">
            <TrendingDown className="h-8 w-8 text-red-100" />
            <div className="ml-4">
              <p className="text-red-100">Saídas</p>
              <p className="text-xl md:text-2xl font-bold">{formatCurrency(stats.total_saida)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="bg-gradient-to-r from-blue-500 to-blue-600 text-white">
        <CardContent className="p-6">
          <div className="flex items-center">
            <DollarSign className="h-8 w-8 text-blue-100" />
            <div className="ml-4">
              <p className="text-blue-100">Vendas</p>
              <p className="text-xl md:text-2xl font-bold">{formatCurrency(stats.total_vendas)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card
        className={`bg-gradient-to-r ${
          totalBankBalance >= 0 ? "from-purple-500 to-purple-600" : "from-orange-500 to-orange-600"
        } text-white`}
      >
        <CardContent className="p-6">
          <div className="flex items-center">
            <BarChart3 className="h-8 w-8 text-white text-opacity-80" />
            <div className="ml-4">
              <p className="text-white text-opacity-80">Saldo</p>
              <p className="text-xl md:text-2xl font-bold" data-testid="dashboard-saldo">
                {formatCurrency(totalBankBalance)}
              </p>
              <p className="text-xs text-white text-opacity-80 mt-0.5">Soma de todas as contas</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
